import { gsap } from 'gsap/all'
import { debounce } from 'throttle-debounce'

export const checkoutPage = (target) => {
  const el = {
    footer: target.querySelector('.checkout-footer'),
    body: document.querySelector('.body'),
  }

  const method = {
    init: () => {
      method.setSpacing()
      window.addEventListener('resize', debounce(120, method.setSpacing))
    },

    setSpacing: () => {
      if (!el.footer || !el.body) return

      gsap.set(el.body, {
        paddingBottom: el.footer.offsetHeight,
      })
    },
  }

  method.init()
}
